// extracted by mini-css-extract-plugin
module.exports = {"formatted-text":"formatted-text__v3_El","bb":"bb__uedGO","bb-text":"bb-text__Gehgy"};